var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Overlay',{attrs:{"theme":"passive"}},[_c('div',{staticClass:"loadingView",style:(_vm.customStyle)},[(_vm.iconName)?_c('svg-icon',{staticClass:"iconBody",attrs:{"name":_vm.iconName}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }